import SelectTableDifferentiaalDiagnoseMetaboleAlkalose from "../../../../src/client/niv_acuteboekje/ui/SelectTableDifferentiaalDiagnoseMetaboleAlkalose.js";
import * as React from 'react';
export default {
  SelectTableDifferentiaalDiagnoseMetaboleAlkalose,
  React
};